<template>
  <Select
    v-model="type"
    :options="typeOptions"
    placeholder="Select a type"
    :disabled="disabled"
    option-label="label"
    option-value="value"
    style="width: 100%"
    :pt="{
      input: { style: { padding: '8px' } },
      root: { style: { border: !hasBorder && 'none' } },
    }"
  >
    <template #value="slotProps">
      <StoreItemTypeBadge :type="slotProps.value" />
    </template>
    <template #option="slotProps">
      <div :class="$style.multiselectOption">
        <StoreItemTypeBadge :type="slotProps.option.value" />
        <VdTooltip v-if="slotProps.option.value === 'NON_CONSUMABLE'" orientation="right" :content="tooltipContent">
          <VdIcon store="fas" name="fa-triangle-exclamation" />
        </VdTooltip>
        <span v-if="slotProps.option.value === 'CONSUMABLE'" :class="$style.defaultLabel">default</span>
      </div>
    </template>
  </Select>
</template>

<script setup lang="ts">
import { VdTooltip } from "@voodoo.io/voodoo-ui";
import Select from "primevue/select";
import { computed } from "vue";

import StoreItemTypeBadge from "@/components/StoreItemTypeBadge";

const props = defineProps({
  hasBorder: {
    type: Boolean,
    default: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String,
    required: true,
  },
});

const emit = defineEmits<{
  (e: "change", type: string): void;
}>();

const type = computed({
  get: () => props.type,
  set: (value) => {
    emit("change", value);
  },
});

const tooltipContent =
  "Non-consumables must be assigned <br /> to an IAP code in the IAP page. <a href='https://www.notion.so/voodoo/Supporting-Non-Consumables-with-Offers-Shop-16fa0b481db480729a96d15ba772945d' target='_blank' rel='noopener noreferrer'>More info</a>";

const typeOptions = [
  { label: "Consumable", value: "CONSUMABLE" },
  { label: "Currency", value: "CURRENCY" },
  { label: "Non Consumable", value: "NON_CONSUMABLE" },
];
</script>

<style module lang="scss">
.multiselectOption {
  display: flex;
  align-items: center;

  svg {
    color: var(--vd-color-yellow-500);
    margin-left: 0.5rem;
  }
}

.defaultLabel {
  color: var(--vd-color-text-light-2);
  margin-left: 0.5rem;
  font-size: 10px;
}
</style>
